// extracted by mini-css-extract-plugin
export default {"container":"XG-z","header":"YG-z","details":"ZG-z","link":"_G-z"};